import React from 'react';

/**
 * Wraps English words in Hebrew text with proper bidirectional isolation
 * to fix display issues where English text appears in reverse order
 */
export const renderMixedText = (text: string): React.ReactNode => {
  // Regex to match English words (letters, numbers, and common punctuation)
  const englishWordRegex = /([A-Za-z0-9]+(?:[A-Za-z0-9\s\-_.]*[A-Za-z0-9]+)?)/g;
  
  const parts = text.split(englishWordRegex);
  
  return parts.map((part, index) => {
    // If this part matches English pattern, wrap it with isolation
    if (englishWordRegex.test(part)) {
      englishWordRegex.lastIndex = 0; // Reset regex
      return (
        <span key={index} className="bidi-isolate" dir="ltr">
          {part}
        </span>
      );
    }
    // Hebrew text remains as is
    return part;
  });
};

/**
 * Component for rendering mixed Hebrew/English text with proper bidirectional support
 */
interface MixedTextProps {
  children: React.ReactNode;
  className?: string;
}

export const MixedText: React.FC<MixedTextProps> = ({ children, className = '' }) => {
  // If children is a string, apply RTL processing
  if (typeof children === 'string') {
    return (
      <span className={`rtl-text ${className}`}>
        {renderMixedText(children)}
      </span>
    );
  }
  
  // Otherwise, render children as-is
  return (
    <span className={`rtl-text ${className}`}>
      {children}
    </span>
  );
}; 